module.exports = __webpack_public_path__ + "img/BI.1cf8bfd9.png";